import { DropdownTrigger } from "@spz/ui/components/dropdown-trigger";
import { cn } from "../../../lib/utils";
import type { DropdownCellProps } from "../types";

export const DropdownCell = <T,>({
  value,
  options,
  onChange,
  disabled = false,
  placeholder,
  className,
}: DropdownCellProps<T>) => {
  return (
    <DropdownTrigger
      className={cn("w-full", className)}
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder || "Select..."}
      disabled={disabled}
      buttonClassName="hover:bg-white"
      alignDropdownContent="start"
    />
  );
};
